/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Modify_DescInputs */

const en_cad_features_modify_desc = /** @type {(inputs: Cad_Features_Modify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim, extend, fillet, offset and array with the same prompts you know. Grips work too: press Space to cycle hot-grip modes between Stretch, Move, Rotate, Scale and Mirror.`)
};

/**
* | output |
* | --- |
* | "Trim, extend, fillet, offset and array with the same prompts you know. Grips work too: press Space to cycle hot-grip modes between Stretch, Move, Rotate, Sca..." |
*
* @param {Cad_Features_Modify_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_modify_desc = /** @type {((inputs?: Cad_Features_Modify_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Modify_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_modify_desc(inputs)
});
export { cad_features_modify_desc as "cad.features.modify_desc" }